export const tableHeaders = [
  {
    id: 1,
    label: 'First activity started',
    intlKey: 'table.first_activity_started',
    sortable: false
  },
  {
    id: 2,
    label: 'Major',
    intlKey: 'table.major',
    sortable: false
  },
  {
    id: 3,
    label: 'Hours Completed/Required',
    intlKey: 'table.hours_completed_required',
    sortable: false
  },
  // {
  //   id: 4,
  //   label: 'Weeks Completed/Required',
  //   sortable: false
  // },
  {
    id: 5,
    label: 'Completed',
    intlKey: 'table.completed',
    sortable: false
  }
]

export const logsHeaders = [
  {
    id: 1,
    label: 'Date',
    intlKey: 'table.date',
    sortable: false
  },
  {
    id: 2,
    label: 'Hours',
    intlKey: 'table.hours',
    sortable: false
  },
  {
    id: 3,
    label: 'Description',
    intlKey: 'table.description',
    sortable: false
  }
]

export const activitiesHeaders = [
  {
    id: 1,
    label: 'Activity',
    intlKey: 'table.activity',
    sortable: false
  },
  {
    id: 2,
    label: 'Hours',
    intlKey: 'table.breakdown_of_hours',
    sortable: false
  }
]
